// extracted by mini-css-extract-plugin
module.exports = {"mainContentPage":"PublicLayout_mainContentPage__kZ4v4"};